const SESSION_KEY = "mu_convocation_session";

export const VIEWER_ROUTES = ["/dashboard", "/registrations", "/checkin-transactions"];

export function getSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setSession(session) {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
}

export function clearSession() {
  sessionStorage.removeItem(SESSION_KEY);
}

export function isAuthenticated() {
  const session = getSession();
  if (!session?.token) return false;
  if (session.expires_at && Date.now() / 1000 > session.expires_at) {
    clearSession();
    return false;
  }
  return true;
}

export function getSessionRole() {
  const session = getSession();
  return session?.role || "admin";
}

export function isViewer() {
  return getSessionRole() === "viewer";
}

export function canWrite() {
  return getSessionRole() === "admin";
}

export function isViewerRoute(pathname) {
  return VIEWER_ROUTES.some((route) => pathname === route || pathname.startsWith(`${route}/`));
}
